import { render, staticRenderFns } from "./dark-footer.vue?vue&type=template&id=33481340"
import script from "./dark-footer.vue?vue&type=script&lang=js"
export * from "./dark-footer.vue?vue&type=script&lang=js"
import style0 from "./dark-footer.vue?vue&type=style&index=0&id=33481340&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports